import React, { useMemo } from 'react';
import { ScatterChart } from "@carbon/charts-react";
import ChartPanelWrapper from "../ChartPanelWrapper";
import { transformToGroupValue, addIndexAndRadius, buildXYChartOptions, buildColorScale } from "../chartHelpers";

const Index = ({chart}) => {
    return (
        <ChartPanelWrapper chart={chart}>
            {(panelData, renderChart) => {
                const data = addIndexAndRadius(transformToGroupValue(panelData, chart));
                const colorScale = buildColorScale(data);
                const chartOptions = {
                    ...buildXYChartOptions(chart),
                    resizable: true,
                    color: { scale: colorScale }
                };
                return renderChart(data, <ScatterChart options={chartOptions} data={data} />);
            }}
        </ChartPanelWrapper>
    );
}

export default React.memo(Index)
